//To register changes in the DOM-structure of compound attributes
import { copyObject, getAttributeNameWithoutPostfix } from '@/core/shared'
import { attributeDataCapture } from '@/core/item_assistance/itemDataCapture'
import { generateDifferentialJson } from '@/core/item_assistance/generatingDifferentialJson'
import { markSidebarItemStateButtons } from '@/core/support_gui_components/sidebar/sidebar'
import { mergeData } from '@/core/item_assistance/mergeItemData'

export function attributeChangesRegister (attributeName) {
	var itemProcessor = !_.isUndefined(window['newTradeItem'])
		? window['newTradeItem'] : !_.isUndefined(window['editableTradeItem'])
			? window['editableTradeItem'] : null
	if (itemProcessor && itemProcessor['unsavedDataManager']) {
		itemProcessor.unsavedDataManager.changesRegister(attributeName)
	}
}

export function UnsavedDataManager (itemProcessor) {
	'use strict'

	var LIST_PREFIX = 'list__'

	var typesToStoreEmpty = {
		'NM': 'val'
	}

	var unsavedData = {}

	attachRegistration(this)

	this.setUnsavedData = function (data) {
		const unsavedDataPrev = this.getUnsavedData()
		if (unsavedData.length !== 0) {
			unsavedData = mergeData(unsavedDataPrev, copyObject(data, true))
		} else {
			unsavedData = copyObject(data, true)
		}
		this.updateUnsavedDataSign()
	}

	this.getUnsavedData = function () {
		return unsavedData
	}

	this.clearData = function () {
		unsavedData = {}
	}

	this.updateUnsavedDataSign = function () {
		markSidebarItemStateButtons(checkToUnsavedStateExists(), checkToUnsavedDataExists())
	}

	function checkToUnsavedStateExists () {
		return !_.isEmpty(unsavedData)
	}

	function attachRegistration (manager) {
		$('div.page').on('change', '.single-attribute', function (e) {
			var $element = $(e.target)
			var attributeName = $element.attr('id').startsWith(LIST_PREFIX)
				? getAttributeNameWithoutPostfix($element.attr('id').substring(LIST_PREFIX.length))
				: getAttributeNameWithoutPostfix($element.attr('id'))
			manager.changesRegister(attributeName)
			e.stopPropagation()
		})
	}

	this.changesRegister = function (attributeName) {
		if (itemProcessor.itemConfig[attributeName]) {
			var capturedData = {}
			var attributeType = itemProcessor.itemConfig[attributeName]['type']
			var isMultipleAttribute = itemProcessor.itemConfig[attributeName]['multiple']
			attributeDataCapture(attributeType, attributeName, isMultipleAttribute, capturedData, { includeEmptyNM: true })

			if (!_.isEmpty(capturedData)) {
				var attribute = {}
				if (!_.isUndefined(itemProcessor.itemData[attributeName])) {
					attribute[attributeName] = _.isObject(itemProcessor.itemData[attributeName])
						? copyObject(itemProcessor.itemData[attributeName], true)
						: itemProcessor.itemData[attributeName]
				}
				//Generate differential JSON for one attribute
				var diff = generateDifferentialJson(capturedData, itemProcessor.itemConfig, attribute, itemProcessor.allAttributesForGroups)
				if (!_.isEmpty(diff)) {
					unsavedData[attributeName] = _.isObject(diff[attributeName]) ? copyObject(diff[attributeName]) : diff[attributeName]
					this.updateUnsavedDataSign()
				} else {
					delete unsavedData[attributeName]
					this.updateUnsavedDataSign()
				}
			}
		}
	}

	function checkToUnsavedDataExists () {
		function isEmptyValue (element, key) {
			return (element[key] == null || _.isNaN(element[key]))
		}

		var result = _.find(unsavedData, function (attributeValue, attributeName) {
			if (!_.isObject(attributeValue)) {
				return true
			} else {
				var type = itemProcessor.itemConfig[attributeName]['type']
				var isMultiple = itemProcessor.itemConfig[attributeName]['multiple']
				if (!isMultiple) {
					return typesToStoreEmpty[type] ? type === 'NM' ? true : !isEmptyValue(attributeValue, typesToStoreEmpty[type]) : true
				} else {
					return !_.isUndefined(_.find(attributeValue, function (val) {
						return typesToStoreEmpty[type] ? !isEmptyValue(val, typesToStoreEmpty[type]) : true
					}))
				}
			}
			return false
		})
		return !_.isUndefined(result)
	}
}
